module.exports = __webpack_public_path__ + "img/57.819ac87f.webp";